import { createRouter, createWebHistory } from "vue-router";
import pinia from "@/store/pinia";
import { useAuthSessionStore } from "@/store/pinia/useAuthSessionStore";
import {
  TIME_MANAGEMENT_LOGGING_TABS,
  OVERVIEW_TABS,
  RALLOC_TABS_ENUM,
  PROJECT_TABS,
} from "@/utils/const";

const Other = () => import("@/views/Other.vue");
const EnterpriseProjectList = () =>
  import("@/views/enterprise/project/ProjectList");
const EnterpriseProjectWorklog = () =>
  import("@/views/enterprise/project/ProjectWorklog");
const EnterpriseProjectTask = () =>
  import("@/views/enterprise/project/ProjectTask");
const EnterpriseClientList = () =>
  import("@/views/enterprise/client/ClientsPage");
const EnterpriseProjectCreate = () =>
  import("@/views/enterprise/project/ProjectCreate");
const ProjectDetailsPage = () =>
  import("@/views/enterprise/project/ProjectDetailsPage");
const ProjectDetailsTabPlaceholder = () =>
  import("@/views/enterprise/project/details/TabPlaceholder");
const ProjectDetailsNotesTab = () =>
  import("@/views/enterprise/project/details/notes/NotesTab");
const ProjectDetailsContractsTab = () =>
  import("@/views/enterprise/project/details/contracts/ContractsTab");
const ProjectDetailsPeopleTab = () =>
  import("@/views/enterprise/project/details/people/PeopleTab");
const ProjectDetailsResourcesTab = () =>
  import("@/views/enterprise/project/details/resources/ResourcesTab");
const ProjectDetailsTasksTab = () =>
  import("@/views/enterprise/project/details/tasks/TasksTab");
const ProjectDetailsWorklogsTab = () =>
  import("@/views/enterprise/project/details/worklogs/WorklogsTab");
const ProjectDetailsExternalCostsTab = () =>
  import("@/views/enterprise/project/details/external-costs/ExternalCostsTab");
const ProjectDetailsInvoicesTab = () =>
  import("@/views/enterprise/project/details/invoices/InvoicesTab");
const EnterpriseTiers = () => import("@/views/enterprise/tiers/Tiers");
const EnterpriseOverview = () => import("@/views/enterprise/admin/Overview");
const InvoiceList = () => import("@/views/enterprise/invoices/InvoiceList.vue");
const TenantList = () => import("@/views/tenant/TenantList");
const AbsenceRequestsAdmin = () =>
  import("@/views/absence/request/AllAbsenceRequests");
const AbsenceReports = () => import("@/views/absence/Reports");
const AdminRequest = () => import("@/views/absence/request/AdminRequest");
const SettingsSpecialDaysPage = () =>
  import("@/views/settings/special-days/SpecialDaysPage");
const SettingsWorkSchedulePage = () =>
  import("@/views/settings/work-schedule/WorkSchedulePage");
const SettingsCurrencyManagerPage = () =>
  import("@/views/settings/currency-manager/CurrencyManagerPage");
const SettingsRateCardPage = () =>
  import("@/views/settings/rate-card/RateCardPage");
const SettingsHolidaysPage = () =>
  import("@/views/settings/holidays/HolidaysPage");
const SettingsPermissionPresetsPage = () =>
  import("@/views/settings/permission-preset/PermissionPresetsPage");
const AbsenceHandleAbsenceRequestList = () =>
  import("@/views/absence/request/HandleAbsenceRequestList");
const AbsenceHandleAbsenceRequestForm = () =>
  import("@/views/absence/request/HandleAbsenceRequestForm");
const QuotaList = () => import("@/views/absence/quota/QuotaList");
const QuotaForm = () => import("@/views/absence/quota/QuotaForm");
const ProjectDimensions = () =>
  import("@/views/enterprise/project/dimension/ProjectDimensions.vue");
const ProjectDimensionAssigner = () =>
  import("@/views/enterprise/project/dimension/ProjectDimensionAssigner.vue");
const ProjectBaseData = () =>
  import("@/views/enterprise/project/ProjectBaseData.vue");
const OvertimePolicies = () =>
  import("@/views/settings/overtime-policies/OvertimePoliciesPage.vue");
const HandleOvertimeRequestList = () =>
  import("@/views/enterprise/overtime/request/HandleOvertimeRequestList");
const HandleOvertimeRequestForm = () =>
  import("@/views/enterprise/overtime/request/HandleOvertimeRequestForm");
const RequestsPage = () => import("@/views/request/RequestsPage");
const MyRequestsPage = () => import("@/views/request/MyRequestsPage");
const RiskManagement = () => import("@/views/enterprise/admin/RiskManagement");
const Statistics = () => import("@/views/enterprise/admin/Statistics");
const UserIndicatorList = () =>
  import("@/views/census/indicator/UserIndicatorList");
const AbsenceTypeList = () => import("@/views/absence/type/AbsenceTypeList");
const ProfilePage = () => import("@/views/user-management/ProfilePage");
const SignIn = () => import("@/views/SignIn");
const UserRegistration = () => import("@/views/UserRegistration.vue");
const RootSignIn = () => import("@/views/RootSignIn.vue");
const ForgotPassword = () => import("@/views/ForgotPassword.vue");
const Invite = () => import("@/views/Invite.vue");
const Permissions = () =>
  import("@/views/census/permission/UserPermissionList");
const HandePermissionRequestList = () =>
  import("@/views/census/permission/HandlePermissionRequestList");
const ResetPassword = () => import("@/views/ResetPassword");
const ActiveLoginsList = () => import("@/views/session/ActiveLoginsList");
const AdminConfigEdit = () =>
  import("@/views/admin-config/AdminConfigEdit.vue");
const ExecutiveDashboard = () =>
  import("@/views/enterprise/admin/ExecutiveDashboard.vue");
const UploadAssociations = () =>
  import("@/views/ralloc/UploadAssociations.vue");
const ProjectAggregationView = () =>
  import("@/views/enterprise/project/aggregation/ProjectAggregationView.vue");
const ProjectAggregationListView = () =>
  import(
    "@/views/enterprise/project/aggregation/ProjectAggregationListView.vue"
  );
const SettingsView = () => import("@/views/settings/SettingsView.vue");
const TimeManagementOverview = () => import("@/views/time-management/TimeManagementOverview.vue");
const SettingsRolesPage = () => import("@/views/settings/role/RolesPage.vue");
const SettingsSeniorityPage = () =>
  import("@/views/settings/seniority/SeniorityPage.vue");
const SettingsCompetencyPage = () =>
  import("@/views/settings/competency/CompetencyPage.vue");
const AppIntegrations = () =>
  import("@/views/admin-config/AppIntegrations.vue");
const SuccessAuthCallbackPage = () =>
  import("@/views/admin-config/oauth/SuccessAuthCallbackPage.vue");
const ErrorAuthCallbackPage = () =>
  import("@/views/admin-config/oauth/ErrorAuthCallbackPage.vue");
const RallocMainPage = () => import("@/views/ralloc/RallocMainPage.vue");
const ProjectResourceView = () =>
  import("@/views/ralloc/ProjectResourceView.vue");
const TimeManagementLoggingView = () =>
  import("@/views/time-management/TimeManagementLoggingView.vue");
const RiportListPage = () => import("@/views/riporting/RiportListPage.vue");
const RiportDisplayPage = () =>
  import("@/views/riporting/RiportDisplayPage.vue");
const MyAbsenceRequestsPage = () =>
  import("@/views/absence/MyAbsenceRequestsPage.vue");
const AbsenceRequestPage = () =>
  import("@/views/absence/AbsenceRequestPage.vue");
const OvertimeRequestPage = () =>
  import("@/views/enterprise/overtime/request/OvertimeRequestPage.vue");
const FinancialDashboard = () =>
  import("@/views/dashboard/FinancialDashboard.vue");
const UniversalDashboard = () =>
  import("@/views/dashboard/UniversalDashboard.vue");
const EmployeeExplorer = () => import("@/views/employee/EmployeeExplorer.vue");
const TeamsPage = () => import("@/views/teams/TeamsPage.vue");
const SettingsUserManagementPage = () =>
  import("@/views/settings/user-management/UserManagementPage");

// TODO add "authorities" to route metas when ready
const routes = [
  // New Refined Pages
  {
    path: "/time-management/logging",
    name: "TimeManagementLogging",
    component: TimeManagementLoggingView,
    meta: {
      breadcrumb: (route) => {
        let secondBreadcrumb;
        switch (route.query?.tab) {
          case TIME_MANAGEMENT_LOGGING_TABS.DAILY:
            secondBreadcrumb = {
              label: "timeManagement.daily|Napi",
            };
            break;
          case TIME_MANAGEMENT_LOGGING_TABS.TIMESHEET:
            secondBreadcrumb = {
              label: "timeManagement.timesheet|Timesheet",
            };
            break;
          case TIME_MANAGEMENT_LOGGING_TABS.IMPORT:
            secondBreadcrumb = {
              label: "timeManagement.import|Import",
            };
            break;
          default:
            secondBreadcrumb = {
              label: "timeManagement.daily|Napi",
            };
            break;
        }
        return [
          { label: "sidebar.time|Időkezelés" },
          { label: "sidebar.time.timeLogging|Időkövetés" },
          secondBreadcrumb,
        ];
      },
    },
  },
  {
    path: "/reporting/my-reports",
    name: "ReportingMyReports",
    component: RiportListPage,
    props: {
      factory: false,
    },
    meta: {
      breadcrumb: [
        { label: "sidebar.reporting.menu|Jelentések" },
        { label: "reporting.breadcrumbs.mine|Riportjaim" },
      ],
    },
  },
  {
    path: "/reporting/reports",
    name: "ReportingFactoryReports",
    component: RiportListPage,
    props: {
      factory: true,
    },
    meta: {
      breadcrumb: [
        { label: "sidebar.reporting.menu|Jelentések" },
        { label: "reporting.breadcrumbs.factory|Riportjaim" },
      ],
    },
  },
  {
    path: "/reporting/report/:id?",
    name: "RiportDisplayPage",
    component: RiportDisplayPage,
    meta: {
      sidebarItemKey: "controlling.aggregation",
      breadcrumb: (route) => [
        { label: "sidebar.reporting.menu|Jelentések" },
        {
          label: "reporting.breadcrumbs.factory|Riportok",
          to: "/reporting/reports",
        },
        {
          label: route.params?.id
            ? `reportDisplay.view_aggregation|View Report`
            : "reportDisplay.new_aggregation|New Report",
        },
      ],
    },
  },
  // Old Main views
  {
    path: "/",
    name: "Home",
    component: useAuthSessionStore(pinia).isRoot
      ? TenantList
      : TimeManagementOverview,
    meta: {
      breadcrumb: (route) => {
        let secondBreadcrumb;
        switch (route.query?.tab) {
          case OVERVIEW_TABS.LOGGED_TIME.value:
            secondBreadcrumb = {
              label: "timeManagement.loggedTime|Logolások",
            };
            break;
          case OVERVIEW_TABS.TIME_OFF.value:
            secondBreadcrumb = {
              label: "timeManagement.timeOff|Szabadságok",
            };
            break;
          default:
            secondBreadcrumb = {
              label: "timeManagement.loggedTime|Logolások",
            };
            break;
        }
        return [
          { label: "sidebar.time|Időkezelés" },
          { label: "sidebar.time.overview|Áttekintés" },
          secondBreadcrumb,
        ];
      },
    },
  },
  {
    path: "/statistics",
    name: "ControllingStatistics",
    component: Statistics,
    meta: {
    },
  },
  // Absence pages
  {
    path: "/my-absence-requests",
    name: "MyAbsenceRequests",
    component: MyAbsenceRequestsPage,
    meta: {
      breadcrumb: [
        { label: "sidebar.time|Időkezelés" },
        { label: "myAbsenceRequestsPage.title|Szabadságkérelem" },
      ],
    },
  },
  {
    path: "/absence-request/:id",
    name: "AbsenceRequest",
    component: AbsenceRequestPage,
    props: true,

    meta: {
      sidebarItemKey: "requests",

      breadcrumb: [
        { label: "sidebar.time|Időkezelés" },
        {
          label: "requests.breadcrumb|Requests",
          to: "/requests",
        },
        { label: "absenceRequestPage.title|Távollátkérelem áttekintése" },
      ],
    },
  },
  // AbsenceAdmin pages
  {
    path: "/absence/admin/requests",
    name: "AbsenceAdminRequests",
    component: AbsenceRequestsAdmin,
    meta: {
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/absence/admin/create",
    name: "AbsenceAdminCreate",
    component: AdminRequest,
    meta: {
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/absence/admin/quotas",
    name: "AbsenceQuotas",
    component: QuotaList,
    meta: {
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/absence/admin/quota/:year",
    name: "AbsenceQuota",
    component: QuotaForm,
    meta: {
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/absence/admin/reports",
    name: "AbsenceReports",
    component: AbsenceReports,
    meta: {
    },
  },
  // Controlling pages
  {
    path: "/controlling/dashboard",
    name: "ControllingDashboard",
    component: ExecutiveDashboard,
    meta: {
    },
  },
  {
    path: "/controlling/project-aggregation/:id?",
    name: "ProjectAggregation",
    component: ProjectAggregationView,
    meta: {
    },
  },
  {
    path: "/controlling/aggregation-list",
    name: "AggregationSettings",
    component: ProjectAggregationListView,
    meta: {
    },
  },
  {
    path: "/projects/list",
    name: "ControllingProjects",
    component: EnterpriseProjectList,
    meta: {
      breadcrumb: (route) => {
        let secondBreadcrumb;
        switch (route.hash) {
          case PROJECT_TABS.HASH.ALL:
            secondBreadcrumb = {
              label: "sidebar.projects.all|Összevont",
            };
            break;
          case PROJECT_TABS.HASH.SIMPLE:
            secondBreadcrumb = {
              label: "sidebar.projects.normal|Hagyományos",
            };
            break;
          case PROJECT_TABS.HASH.SUPPORT:
            secondBreadcrumb = {
              label: "sidebar.projects.support|Folyamatos",
            };
            break;
          case PROJECT_TABS.HASH.OUTSOURCE:
            secondBreadcrumb = {
              label: "sidebar.projects.outsource|Outsource",
            };
            break;
          case PROJECT_TABS.HASH.MONEYLESS:
            secondBreadcrumb = {
              label: "sidebar.projects.moneyless|Publikus",
            };
            break;
          default:
            secondBreadcrumb = {
              label: "sidebar.projects.all|Összevont",
            };
            break;
        }
        return [{ label: "sidebar.projects.menu|Projektek" }, secondBreadcrumb];
      },
    },
  },
  {
    path: "/projects/worklog",
    name: "ControllingProjectsWorklog",
    component: EnterpriseProjectWorklog,
    meta: {
      breadcrumb: [
        { label: "sidebar.projects.menu|Projektek" },
        { label: "sidebar.projects.worklog|Munkaütemezés" },
      ],
    },
  },
  {
    path: "/projects/task",
    name: "ControllingProjectsTask",
    component: EnterpriseProjectTask,
    meta: {
      breadcrumb: [
        { label: "sidebar.projects.menu|Projektek" },
        { label: "sidebar.projects.task|Feladatok" },
      ],
    },
  },
  {
    path: "/projects/clients",
    name: "SettingsClients",
    component: EnterpriseClientList,
    meta: {
      breadcrumb: [
        { label: "sidebar.projects.menu|Projektek" },
        { label: "sidebar.projects.clients|Ügyfelek" },
      ],
    },
  },
  {
    path: "/projects/project-create",
    name: "ControllingProjectCreate",
    component: EnterpriseProjectCreate,
    meta: {
    },
  },
  {
    path: "/projects/:id(\\d+)",
    component: ProjectDetailsPage,
    meta: {
      sidebarItemKey: "projects.simple",
      breadcrumb: [
        {
          label: "projects.breadcrumb.projects|Projects",
          to: "/projects/list",
        },
        { label: "Website Redesign 2025" },
      ],
    },
    children: [
      { path: "", redirect: (to) => `/projects/${to.params.id}/dashboard` },
      {
        path: "dashboard",
        name: "ProjectDetails.dashboard",
        component: ProjectDetailsTabPlaceholder,
        props: { label: "Dashboard" },
      },
      {
        path: "notes",
        name: "ProjectDetails.notes",
        component: ProjectDetailsNotesTab,
      },
      {
        path: "contracts",
        name: "ProjectDetails.contracts",
        component: ProjectDetailsContractsTab,
      },
      {
        path: "people",
        name: "ProjectDetails.people",
        component: ProjectDetailsPeopleTab,
      },
      {
        path: "resources",
        name: "ProjectDetails.resources",
        component: ProjectDetailsResourcesTab,
      },
      {
        path: "tasks",
        name: "ProjectDetails.tasks",
        component: ProjectDetailsTasksTab,
      },
      {
        path: "worklogs",
        name: "ProjectDetails.worklogs",
        component: ProjectDetailsWorklogsTab,
      },
      {
        path: "external-costs",
        name: "ProjectDetails.external-costs",
        component: ProjectDetailsExternalCostsTab,
      },
      {
        path: "invoices",
        name: "ProjectDetails.invoices",
        component: ProjectDetailsInvoicesTab,
      },
      {
        path: "alerts",
        name: "ProjectDetails.alerts",
        component: ProjectDetailsTabPlaceholder,
        props: { label: "Alerts" },
      },
      {
        path: "advanced",
        name: "ProjectDetails.advanced",
        component: ProjectDetailsTabPlaceholder,
        props: { label: "Advanced" },
      },
    ],
  },
  {
    path: "/controlling/query",
    name: "ControllingQuery",
    component: EnterpriseOverview,
    meta: {
      breadcrumb: [
        { label: "sidebar.controlling.menu|Felügyelet" },
        { label: "sidebar.controlling.timesheet_query|Lekérdezés" },
      ],
    },
    props: {
      showMoney: true,
    },
  },
  {
    path: "/controlling/risk-management",
    name: "ControllingRiskManagement",
    component: RiskManagement,
    meta: {
      breadcrumb: [
        { label: "sidebar.controlling.menu|Felügyelet" },
        { label: "sidebar.controlling.risk_management|Kockázatmenedzsment" },
      ],
    },
  },
  {
    path: "/approval/permissions",
    name: "UserPermissionList",
    component: HandePermissionRequestList,
  },
  {
    path: "/controlling/logins",
    name: "ActiveLoginsList",
    component: ActiveLoginsList,
    meta: {
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/controlling/invoices",
    name: "InvoiceList",
    component: InvoiceList,
    meta: {
      breadcrumb: [
        { label: "sidebar.projects.menu|Projects", to: "/projects/list" },
        { label: "invoiceList.title|Számlák" },
      ],
    },
  },
  {
    path: "/controlling/upload-associations",
    name: "UploadAssociations",
    component: UploadAssociations,
    meta: {
    },
  },
  {
    path: "/ralloc/utilization",
    name: "RallocMainPage",
    component: RallocMainPage,
    meta: {
      breadcrumb: (route) => {
        let secondBreadcrumb;
        switch (route.query?.tab) {
          case RALLOC_TABS_ENUM.EMPLOYEES.value:
            secondBreadcrumb = {
              label: "timeManagement.employees|Alkalmazottak",
            };
            break;
          case RALLOC_TABS_ENUM.PROJECTS.value:
            secondBreadcrumb = {
              label: "timeManagement.projects|Projektek",
            };
            break;
          default:
            secondBreadcrumb = {
              label: "timeManagement.projects|Projektek",
            };
            break;
        }
        return [
          { label: "sidebar.resource|Erőforrások" },
          { label: "sidebar.resource.ralloc.utilization|Erőforrás-tervezés" },
          secondBreadcrumb,
        ];
      },
    },
  },
  {
    path: "/employee-explorer",
    name: "EmployeeExplorer",
    component: EmployeeExplorer,
    meta: {
      breadcrumb: [
        { label: "sidebar.resource|Erőforrások" },
        { label: "sidebar.resource.employeeExplorer|Felhasználó-böngésző" },
      ],
    },
  },
  {
    path: "/teams",
    name: "TeamsPage",
    component: TeamsPage,
    meta: {
      breadcrumb: [
        { label: "sidebar.resource|Erőforrások" },
        { label: "sidebar.resource.teams|Csapatok" },
      ],
    },
  },
  {
    path: "/ralloc/project/:id",
    name: "ProjectResourceView",
    component: ProjectResourceView,
    meta: {
    },
  },
  // Settings pages
  {
    path: "/settings",
    name: "Settings",
    component: SettingsView,
    meta: {
      breadcrumb: [{ label: "sidebar.settings.menu|Settings" }],
    },
  },
  {
    path: "/settings/user-management",
    name: "SettingsUserManagementPage",
    component: SettingsUserManagementPage,
    meta: {
      sidebarItemKey: "settings",
      breadcrumb: [
        { label: "sidebar.settings.menu|Settings", to: "/settings" },
        { label: "settings.users.tiles.users|Users" },
      ],
    },
  },
  {
    path: "/settings/tiers",
    name: "SettingsTiers",
    component: EnterpriseTiers,
    meta: {
    },
  },
  {
    path: "/settings/project-dimensions",
    name: "SettingsProjectDimensions",
    component: ProjectDimensions,
    meta: {
    },
  },
  {
    path: "/settings/project-dimensions/assign",
    name: "SettingsProjectDimensionsAssign",
    component: ProjectDimensionAssigner,
    meta: {
    },
  },
  {
    path: "/settings/project-base-data",
    name: "SettingsProjectBaseData",
    component: ProjectBaseData,
    meta: {
    },
  },

  {
    path: "/settings/overtime-policies",
    name: "SettingsOvertimePolicies",
    component: OvertimePolicies,
    meta: {
      breadcrumb: [
        { label: "sidebar.settings.menu|Settings", to: "/settings" },
        {
          label: "settings.financial.tiles.overtimePolicies|Overtime Policies",
        },
      ],
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/settings/permissions",
    name: "Permissions",
    component: Permissions,
  },
  {
    path: "/settings/permission-presets",
    name: "PermissionPresetsPage",
    component: SettingsPermissionPresetsPage,
    meta: {
      breadcrumb: [
        { label: "sidebar.settings.menu|Beállítások", to: "/settings" },
        { label: "settings.users.tiles.permissionPresets|Permission Presets" },
      ],
    },
  },
  {
    path: "/settings/tenants",
    name: "TenantList",
    component: TenantList,
  },
  {
    path: "/settings/admin-config",
    name: "AdminConfig",
    component: AdminConfigEdit,
    meta: {
    },
  },
  {
    path: "/settings/roles",
    name: "RolesPage",
    component: SettingsRolesPage,
    meta: {
      breadcrumb: [
        { label: "sidebar.settings.menu|Beállítások", to: "/settings" },
        { label: "settings.users.tiles.roles|Jogkörök" },
      ],
    },
  },
  {
    path: "/settings/seniority",
    name: "SeniorityPage",
    component: SettingsSeniorityPage,
    meta: {
      breadcrumb: [
        { label: "sidebar.settings.menu|Beállítások", to: "/settings" },
        { label: "settings.users.tiles.seniority|Seniority" },
      ],
    },
  },
  {
    path: "/settings/competency",
    name: "CompetencyPage",
    component: SettingsCompetencyPage,
    meta: {
      breadcrumb: [
        { label: "sidebar.settings.menu|Beállítások", to: "/settings" },
        { label: "settings.users.tiles.competencies|Competencies" },
      ],
    },
  },
  {
    path: "/settings/integrations",
    name: "AppIntegrations",
    component: AppIntegrations,
    meta: {
      breadcrumb: [
        { label: "sidebar.settings.menu|Beállítások", to: "/settings" },
        { label: "settings.admin.tiles.integrations|Integrációk" },
      ],
    },
  },
  {
    path: "/settings/integrations/oauth-success",
    name: "SuccessAuthCallbackPage",
    component: SuccessAuthCallbackPage,
    meta: {
      hideSidebar: true,
    },
  },
  {
    path: "/settings/integrations/oauth-failure",
    name: "ErrorAuthCallbackPage",
    component: ErrorAuthCallbackPage,
    meta: {
      hideSidebar: true,
    },
  },
  // Requests pages
  {
    path: "/my-requests",
    name: "MyRequestsPage",
    component: MyRequestsPage,
    meta: {
      sidebarItemKey: "myRequests",
      breadcrumb: [
        { label: "sidebar.time|Időkezelés" },
        { label: "requests.my.breadcrumb|My requests" },
      ],
    },
  },
  {
    path: "/requests",
    name: "RequestsPage",
    component: RequestsPage,
    meta: {
      sidebarItemKey: "requests",
      breadcrumb: [
        { label: "sidebar.time|Időkezelés" },
        { label: "requests.breadcrumb|Requests" },
      ],
    },
  },
  {
    path: "/pending-requests",
    redirect: "/requests",
  },
  {
    path: "/approval/overtime",
    name: "HandleOvertimeRequestList",
    component: HandleOvertimeRequestList,
    meta: {
    },
  },
  {
    path: "/approval/overtime/handle-requests/:id",
    name: "HandleOvertimeRequestForm",
    component: HandleOvertimeRequestForm,
    meta: {
      sidebarItemKey: "requests",
    },
  },
  {
    path: "/overtime-request/:id",
    name: "OvertimeRequest",
    component: OvertimeRequestPage,
    meta: {
      sidebarItemKey: "requests",
      breadcrumb: [
        { label: "sidebar.time|Időkezelés" },
        {
          label: "requests.breadcrumb|Requests",
          to: "/requests",
        },
        { label: "overtimeRequestPage.title|Túlórakérelem áttekintése" },
      ],
    },
    props: true,
  },
  {
    path: "/approval/absence",
    name: "AbsenceHandleAbsenceRequestList",
    component: AbsenceHandleAbsenceRequestList,
    meta: {
    },
  },
  {
    path: "/approval/absence/handle-requests/:id",
    name: "AbsenceHandleAbsenceRequestForm",
    component: AbsenceHandleAbsenceRequestForm,
    meta: {
    },
  },
  // UserAdmin pages
  {
    path: "/census/attributes",
    name: "UserIndicatorList",
    component: UserIndicatorList,
    meta: {
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/absence/types",
    name: "AbsenceTypeList",
    component: AbsenceTypeList,
    meta: {
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/settings/work-schedules",
    name: "SettingsWorkSchedulePage",
    component: SettingsWorkSchedulePage,
    meta: {
      breadcrumb: [
        { label: "sidebar.settings.menu|Settings", to: "/settings" },
        { label: "settings.users.tiles.workschedules|Work Schedules" },
      ],
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/settings/currency-manager",
    name: "SettingsCurrencyManagerPage",
    component: SettingsCurrencyManagerPage,
    meta: {
      breadcrumb: [
        { label: "sidebar.settings.menu|Settings", to: "/settings" },
        { label: "settings.financial.tiles.currencyManager|Currency Manager" },
      ],
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/settings/rate-cards",
    name: "SettingsRateCardPage",
    component: SettingsRateCardPage,
    meta: {
      breadcrumb: [
        { label: "sidebar.settings.menu|Settings", to: "/settings" },
        { label: "settings.financial.tiles.rateCards|Rate Cards" },
      ],
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/settings/holidays",
    name: "SettingsHolidaysPage",
    component: SettingsHolidaysPage,
    meta: {
      breadcrumb: [
        { label: "sidebar.settings.menu|Settings", to: "/settings" },
        { label: "settings.absence.tiles.holidays|Holidays" },
      ],
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/settings/special-days",
    name: "SettingsSpecialDaysPage",
    component: SettingsSpecialDaysPage,
    meta: {
      breadcrumb: [
        { label: "sidebar.settings.menu|Settings", to: "/settings" },
        { label: "settings.absence.tiles.specialDays|Special Days" },
      ],
      sidebarItemKey: "settings",
    },
  },
  // Dashboardok
  {
    path: "/dashboard/universal",
    name: "UniversalDashboard",
    component: UniversalDashboard,
    meta: {
      breadcrumb: [
        { label: "sidebar.time|Időkezelés" },
        { label: "sidebar.time.universalDashboard|Vezérlőpult" },
      ],
    },
  },

  {
    path: "/dashboard/financial",
    name: "FinancialDashboard",
    component: FinancialDashboard,
    meta: {
      breadcrumb: [
        { label: "sidebar.dashboard|Dashboard" },
        { label: "dashboard.financial.title|Pénzügyi vezérlőpult" },
      ],
    },
  },
  // Többiek
  {
    path: "/profile",
    name: "Profile",
    component: ProfilePage,
    props: true,
    meta: {
      breadcrumb: [
        { label: "sidebar.users|Users", to: "/settings/user-management" },
        { label: "sidebar.profile.own|My Profile" },
      ],
    },
  },
  {
    path: "/user/:id",
    name: "UserProfile",
    component: ProfilePage,
    props: true,
    meta: {
      breadcrumb: (route) => [
        { label: "sidebar.users|Users", to: "/settings/user-management" },
        { label: "sidebar.profile|Profile" },
      ],
    },
  },
  {
    path: "/login",
    name: "SignIn",
    component: SignIn,
    meta: {
      protected: false,
      loginLayout: true,
    },
  },
  {
    path: "/invite/:token",
    name: "Invite",
    component: Invite,
    meta: {
      protected: false,
      loginLayout: true,
    },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: {
      protected: false,
      loginLayout: true,
    },
  },
  {
    path: "/register",
    name: "UserRegistration",
    component: UserRegistration,
    meta: {
      protected: false,
      loginLayout: true,
    },
  },
  {
    path: "/root",
    name: "RootSignIn",
    component: RootSignIn,
    meta: {
      protected: false,
      loginLayout: true,
    },
  },
  {
    path: "/reset-password/:token?",
    name: "Reset Password",
    component: ResetPassword,
    meta: {
      protected: false,
      loginLayout: true,
    },
  },
  {
    path: "/404",
    name: "NotFound",
    component: Other,
    meta: {
      protected: false,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "Other",
    component: Other,
    meta: {
      protected: false,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, _from, next) => {
  console.debug("Routing to " + to.name);
  const authStore = useAuthSessionStore(pinia);
  if (!authStore.bootstrapped) {
    await authStore.bootstrap();
  }
  let isLoggedIn = authStore.isReady;
  if (to.meta && to.meta.protected === false) {
    if (isLoggedIn) {
      if (
        to.name === "Reset Password" ||
        to.name === "Invite"
      ) {
        next();
      } else {
        next({ path: "/" });
      }
    } else {
      next();
    }
  } else {
    if (isLoggedIn && !to.meta?.authorities) {
      next();
    } else if (
      isLoggedIn &&
      to.meta?.authorities &&
      authStore.hasAnyAuthority(...to.meta.authorities)
    ) {
      next();
    } else {
      next({ path: "/login" });
    }
  }
});

export default router;
